// Klaviyo's existing signup form is managed outside Shopify translations.
// Keep its customer-facing copy in Spanish on the Spanish storefront.
(() => {
  const copy = new Map([
    ['GET 15% OFF!', '15 % DE DESCUENTO'],
    ['UNLOCK 15% OFF', 'CONSIGUE UN 15 % DE DESCUENTO'],
    [
      'Sign up to receive 15% off your first order and exclusive access to our best offers.',
      'Suscríbete para recibir un 15 % de descuento en tu primer pedido y acceso exclusivo a nuestras mejores ofertas.',
    ],
    ['Email', 'Correo electrónico'],
    ['SIGN ME UP!', 'QUIERO SUSCRIBIRME'],
    ['NO, THANKS', 'NO, GRACIAS'],
    ['Close dialog', 'Cerrar ventana'],
    ['Close teaser', 'Cerrar promoción'],
  ]);

  const labels = new Map([
    ['Close teaser', 'Cerrar promoción'],
    ['Close dialog', 'Cerrar ventana'],
    ['POPUP Form', 'Formulario de suscripción'],
  ]);

  let queued = false;

  function translate() {
    queued = false;
    document.querySelectorAll('[class*="kl-teaser-"], [role="dialog"][aria-label="POPUP Form"], [role="dialog"][aria-label="Formulario de suscripción"]').forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const original = node.nodeValue;
        const replacement = copy.get(original.trim());
        if (replacement) node.nodeValue = original.replace(original.trim(), replacement);
      }

      for (const element of [container, ...container.querySelectorAll('[aria-label]')]) {
        const replacement = labels.get(element.getAttribute('aria-label'));
        if (replacement) element.setAttribute('aria-label', replacement);
      }
    });
  }

  function queueTranslation() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(translate);
  }

  const observer = new MutationObserver(queueTranslation);
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  queueTranslation();
})();
